// extracted by mini-css-extract-plugin
export default {"item":"StaffListItem_item__o6dZp","itemActive":"StaffListItem_itemActive__2GpVC"};